import { Outlet, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { useConfig } from "@/contexts/ConfigContext";

export default function AppLayout() {
  const { config } = useConfig();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t mt-16" style={{ borderColor: "hsl(var(--border))" }}>
        <div className="container-app py-8 flex flex-wrap items-center justify-between gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Colega Link" className="w-7 h-7 rounded-full object-cover"/>
            <span>© {new Date().getFullYear()} Colega Link — Conecta · Delega · Resuelve</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/planes" className="hover:text-foreground" data-testid="footer-planes-link">Planes</Link>
            {config.new_mediation_enabled && (
              <Link to="/mediacion-familiar" className="hover:text-foreground" data-testid="footer-mediacion-familiar-link">Mediación Familiar</Link>
            )}
            <Link to="/terminos" className="hover:text-foreground" data-testid="footer-terms-link">Términos</Link>
            <span className="label-eyebrow">v0.2 · MVP</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
